import React from 'react';
import PropTypes from 'prop-types';
import routes from 'routes';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Link } from 'react-router-dom';
import ShortDate from 'common/ShortDate';
import IconButton from '@material-ui/core/IconButton';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

const BookingList = ({ bookings, onSendEmailButtonClick }) => {
    if(bookings.length === 0) {
        return null;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Booking ID</TableCell>
                    <TableCell>Tenant</TableCell>
                    <TableCell>Start date</TableCell>
                    <TableCell>End date</TableCell>
                    <TableCell>Actual end date</TableCell>
                    <TableCell/>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    bookings.map(booking => (
                        <TableRow key={booking.id}>
                            <TableCell><Link to={routes.admin.booking.replace(':bookingId', booking.id)}>{booking.id}</Link></TableCell>
                            <TableCell>{booking.tenantName}</TableCell>
                            <TableCell><ShortDate value={booking.startDate}/></TableCell>
                            <TableCell><ShortDate value={booking.endDate}/></TableCell>
                            <TableCell><ShortDate value={booking.actualEndDate}/></TableCell>
                            <TableCell align="right">
                                <IconButton
                                    onClick={() => onSendEmailButtonClick(booking)}
                                >
                                    <MailOutlineIcon/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    );
};

BookingList.propTypes = {
    bookings: PropTypes.array.isRequired,
    onSendEmailButtonClick: PropTypes.func.isRequired
};

export default BookingList;
